import React from "react"
import styled from "styled-components"
import PtmApplicationStatus from "../PtmApplicationStatus"
import { PTM_APPLICATION_TYPES } from "../../utils/prospect/ptmApplicationStatus"

const ApplicationStatusBlock = styled.div`
  width: 100%;
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.$centered ? "center" : "flex-start")};
  gap: 4px;
`

/**
 * Renders in-flight / denied PTM application status for Associate and Affiliate
 * paths from buildReapplyPathOffer action state.
 */
const ReapplyPathOfferStatuses = ({
  associateAction,
  affiliateAction,
  associateApplication,
  affiliateApplication,
  centered = false,
}) => {
  if (!associateAction?.showStatus && !affiliateAction?.showStatus) {
    return null
  }

  return (
    <ApplicationStatusBlock $centered={centered}>
      {associateAction?.showStatus ? (
        <PtmApplicationStatus
          status={associateApplication.status}
          registrationStatus={associateApplication.registrationStatus}
          date={
            associateAction.showDeniedStatus
              ? associateApplication.updatedAt
              : undefined
          }
          applicationType={PTM_APPLICATION_TYPES.ASSOCIATE}
          centered={centered}
        />
      ) : null}
      {affiliateAction?.showStatus ? (
        <PtmApplicationStatus
          status={affiliateApplication.status}
          registrationStatus={affiliateApplication.registrationStatus}
          date={
            affiliateAction.showDeniedStatus
              ? affiliateApplication.updatedAt
              : undefined
          }
          applicationType={PTM_APPLICATION_TYPES.AFFILIATE}
          centered={centered}
        />
      ) : null}
    </ApplicationStatusBlock>
  )
}

export default ReapplyPathOfferStatuses
